import React, {useEffect, useState} from 'react'
import {Container} from './styled'
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
const Per = props => {
    const filters = [
        {id: 'channel', text: 'canal'},
        {id: 'category', text: 'categoria'},
        {id: 'department', text: 'departamento'}
    ]
    const {t} = props
    const {filter, setFilter} = props.filter
    const [per, setPer] = useState(filter.per ? filter.per : '')
    useEffect(() => {
        setFilter({per})
    }, [per])
    return <Container>
        <h5>Filtrar por</h5>
        <Select
            value={per}
            displayEmpty
            onChange={({target}) => setPer(target.value)}
            input={<OutlinedInput classes={{root: 'select-operator'}} />}
            classes={{selectMenu: 'select-operator_container'}}
            renderValue={selected => (
                selected === '' ? <em>Selecione um filtro</em> : <em>
                    Por {filters.filter(x => x.id === selected)[0].text}
                </em>
            )}>

            {
                filters.map(x => (
                    <MenuItem value={x.id} key={x.id}>
                        Por {x.text}
                    </MenuItem>
                ))
            }
        </Select>
    </Container>
}

export default Per